import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "_flex _gap-2 _ai-st _js-st _grow-1" }
const _hoisted_2 = {
  key: 0,
  class: "_as-fs _shrink-0"
}
const _hoisted_3 = { class: "_flexcol _grow-1 _tc--dark _ov-h" }
const _hoisted_4 = {
  key: 1,
  class: "_whs-nw _ml-4 _shrink-0 _flex _gap-2 _ai-c _tc--dark"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.prefix)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "prefix")
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.$slots.suffix)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "suffix")
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}